import { IconHourglassEmpty } from '@tabler/icons-react';
import React from 'react';

const SimpleEmptyState = ({ 
  title = "No items yet", 
  description = "Add items to get started" 
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] p-8 text-center text-gray-500">
      <div className="w-16 h-16 mb-4 text-gray-400 opacity-70">
        <IconHourglassEmpty size={64} />
      </div>
      
      {title !== '' && <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {title}
      </h3>}
      
      {description && (
        <p className="text-gray-600 dark:text-gray-400">
          {description}
        </p>
      )}
    </div>
  );
};

export default SimpleEmptyState;